// Packages
import React from 'react';
import { KiteGrid, KiteGridCell } from '@kite/react-kite';
import DexterDev from '../../../static/images/dexter-dev.png';

// Components
import AuthLayout from '../../components/AuthLayout';

import './Home.scss';

const Home = () => {
  return (
    <AuthLayout className="home">
      <KiteGrid>
        <KiteGridCell col={12}>
          <h1>Welcome to Dexter Dev Labs</h1>
        </KiteGridCell>
        <KiteGridCell className="logo-container" col={12}>
          <img src={DexterDev} alt="Dexter Dev Labs Logo" />
        </KiteGridCell>
      </KiteGrid>
    </AuthLayout>
  );
};

export default Home;
